import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private msalService: MsalService) {}

  canActivate(): boolean {
    const jwtToken = localStorage.getItem('jwtToken');
    const userLogin = localStorage.getItem('usuarioLogin');
    const isFakeLogin = localStorage.getItem('isFakeLogin') === 'true';

    if ((jwtToken && userLogin) || (isFakeLogin && jwtToken && userLogin)) {
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }
}